import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import { checkRegistrationProgress } from '@api/employerRegistration';
import { matchError } from '@api/util';
import { RegistrationProgress, VerifyEmailData } from '@model/employer';
import WithRender from './CheckProgress.html';

@WithRender
@Component({})
export default class CheckProgress extends Vue {

    @Prop()
    public verifyEmailData: VerifyEmailData;

    public registrationProgress: RegistrationProgress[] = [];

    public status: string = '';

    public checkProgressInterval: any = null;

    public created() {

        window.scrollTo(0, 0);

        this.checkProgress();

        this.checkProgressInterval = setInterval(() => {
            this.checkProgress();
        }, 10000);
    }

    public checkProgress() {
        checkRegistrationProgress(this.verifyEmailData.requestId)
                .then((response) => {
                    this.status = response.status;
                    this.registrationProgress = response.progress.sort((a, b) => a.ordinalPosition - b.ordinalPosition);

                    if (response.status === 'Complete') {
                        clearInterval(this.checkProgressInterval);
                        this.$emit('next', 6);
                    }
                })
                .catch(matchError({
                    anyError: () => {
                        const message = 'Something went wrong! checkTenant err';
                        this.$snackbar.error({ message });
                    }
                }));
    }
}
